import React from 'react';

export const BoardResizeHandle = ({
  dataAttrName,
  visible = false,
  onPointerDown,
}) => (
  <div
    {...(dataAttrName ? { [dataAttrName]: 'true' } : {})}
    data-testid='resize-handle'
    className={`absolute bottom-0 right-0 h-2.5 w-2.5 border-b-2 border-r-2 border-primary cursor-se-resize transition ${
      visible
        ? 'opacity-100 pointer-events-auto'
        : 'opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto'
    }`}
    onPointerDown={onPointerDown}
    onMouseDown={event => {
      event.preventDefault();
      event.stopPropagation();
    }}
  />
);
